import { Spinner } from "./spinner";

const GlobalSpinner = () => {
  return (
    <div className="absolute top-1 right-1 w-5 h-5 z-[9999]">
      <Spinner />
    </div>
  );
};

export default GlobalSpinner;
